import styled from 'styled-components';

import { useConnectOnboardWalletModalActions } from '#/features/wallet/modal-connect-onboard-context';
import { useTranslation } from '#/features/localization/utils';

import { c7A35CB, cFFFFFF } from '#/colors';

export default function WalletBadgeConnect() {
  const modalActions = useConnectOnboardWalletModalActions();
  const { t } = useTranslation();
  return <Button onClick={modalActions.open}>{t('Connect Wallet')}</Button>;
}

export const Button = styled.button.attrs({ type: 'button' })`
  background-color: ${c7A35CB};
  border-radius: 7px;
  border: none;
  color: ${cFFFFFF};
  font-size: 13px;
  font-weight: 700;
  height: 32px;
  width: 138px;
`;
